import { DatepickerRangeModel } from '../../../../../../common/models/datepicker.model';
import { LocalDateModel, LocalDateRangeModel } from '../../../../../models';
import { ONE_SLOT_MINUTES } from '../../constants';
import { getSlotHeight, getSlotTopPosition } from '../../utils/calendar.utils';
import { AllocationCalendarTruckInfo } from './allocation-calendar-truck-info.model';
import { AllocationCalendarUliInfo } from './allocation-calendar-uli-info.model';
import { AllocationCalendarSlotPosition } from './calendar-slot-position.model';
import { AllocationCalendarDock } from './allocation-calendar-dock.model';

export enum SlotTypeEnum {
  Uli = 'ULI',
  Rule = 'RULE',
}

export class SlotDetails {
  compartmentId: number;
  compartmentName: string;
  slot: AllocationCalendarSlot;
  type: SlotTypeEnum;

  constructor(slotClickDetails: SlotDetails) {
    if (!slotClickDetails) {
      return;
    }
    Object.assign(this, slotClickDetails);
  }
}

export class SlotCompactInfo {
  timeFrame: LocalDateRangeModel = null;
  compartmentId: number;
  ruleId: number;
  slotId?: string;

  constructor(params?: SlotCompactInfo) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class AllocationCalendarSlot {
  slotId: number;
  ruleInfo: { id: number; name: string };
  placeholder: boolean;
  restricted: boolean;
  truckInfo: AllocationCalendarTruckInfo;
  uliInfos: AllocationCalendarUliInfo[];
  timeFrame: LocalDateRangeModel;
  slotPosition?: AllocationCalendarSlotPosition;

  constructor(slot: AllocationCalendarSlot, timeFrame: DatepickerRangeModel, oneSlotPxHeight: number) {
    if (!slot) {
      return;
    }
    Object.assign(this, slot);

    const oneMinutePxHeight: number = oneSlotPxHeight / ONE_SLOT_MINUTES;
    const start: number = +LocalDateModel.getLocalDateByOffset(slot?.timeFrame?.start);
    const end: number = +LocalDateModel.getLocalDateByOffset(slot?.timeFrame?.end);

    this.slotPosition = new AllocationCalendarSlotPosition({
      top: getSlotTopPosition(timeFrame, start, oneMinutePxHeight),
      height: getSlotHeight(timeFrame, { start, end }, oneMinutePxHeight),
    });
  }
}

export interface AllocationCalendarManualSlot {
  slot: AllocationCalendarSlot;
  dock: AllocationCalendarDock;
}
